export const FETCH_SHOW_MODAL = 'FETCH_SHOW_MODAL';
export const FETCH_HIDE_MODAL = 'FETCH_HIDE_MODAL';
export const CAMBIAESTADOMODAL = 'CAMBIAESTADOMODAL';
export const OCULTACAMBIAESTADOMODAL = 'OCULTACAMBIAESTADOMODAL';
export const SHOWBUSCADOR = 'SHOWBUSCADOR';
export const SHOWACCIONES = 'SHOWACCIONES';
export const FETCH_RESET_RESULT = 'FETCH_RESET_RESULT';
export const BUTTON_ADD = 'BUTTON_ADD';